import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

class SrtSearchService {
    async startSearch(folderPath, query, wholeWord = true) {
        const headers = getAuthHeaders();
        const apiBaseUrl = process.env.REACT_APP_API_URL;
        const response = await axios.post(
            `${apiBaseUrl}/api/srt-search`,
            { folderPath, query, wholeWord },
            { headers },
        );
        return response.data;
    }

    async getStatus(jobId) {
        const headers = getAuthHeaders();
        const apiBaseUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(
            `${apiBaseUrl}/api/srt-search/status/${jobId}`,
            { headers },
        );
        return response.data;
    }
}

const srtSearchServiceInstance = new SrtSearchService();
export default srtSearchServiceInstance;
